<template>
  <button
    :disabled="disabled"
    v-on="$listeners"
  >
    <component
      :is="linkComponent"
      :class="clsx('white-fancy-button', { 'white-fancy-button--disabled': disabled })"
      v-bind="linkProps"
    >
      <slot />
      <ChevronsRightLineIcon :size="20" color="#EB883B" />
    </component>
  </button>
</template>

<script>
import clsx from 'clsx';
import { ChevronsRightLineIcon } from '@/shared/ui/icons';
import { HashAnchor, SmartLink } from '@/shared/ui/link';

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: null,
    },
    route: {
      type: [Object, String],
      default: null,
    },
    target: {
      type: String,
      default: '_self',
      validator(value) { return ['_blank', '_self', '_parent', '_top'].includes(value); },
    },
    method: {
      type: Function,
      default: null,
    },
    event: {
      type: String,
      default: null,
    },
    hash: {
      type: String,
      default: null,
    },
  },
  methods: { clsx },
  components: { SmartLink, HashAnchor, ChevronsRightLineIcon },
  computed: {
    linkComponent() {
      if (this.hash && !this.url && !this.route) {
        return 'HashAnchor';
      }

      return 'SmartLink';
    },
    linkProps() {
      const props = {
        disabled: this.disabled,
      };
      if (this.linkComponent === 'HashAnchor') {
        return {
          ...props,
          hash: this.hash,
        };
      } else {
        return {
          ...props,
          url: this.url,
          route: this.route,
          target: this.target,
          method: this.method,
          event: this.event,
          hash: this.hash,
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.white-fancy-button {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  background-color: transparent;
  font-family: "IBM Plex Sans", sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #EB883B;
  border: 1px solid #EB883B;
  border-radius: 16px;
  padding: 16px 24px;
  width: 100%;
  transition: background 0.3s ease;

  &:hover {
    background-color: #f1f3f6;
    cursor: pointer;
  }

  &--disabled {
    opacity: 0.5;
    cursor: not-allowed;

    &:hover {
      background-color: #FCFDFF;
    }
  }
}
</style>
